<template lang="html">
    <div class="pb-5">
        <div class="container container-small mb-3">
            <Heading class="py-4" :title="$t('add_profile_title')"></Heading>
            <BillingProfile v-on:input="updateProfileFromComponent($event)" @resetErrors="resetErrorMsgs" :errorMsgs="errorMsgs"></BillingProfile>
            <div class="text-center mt-4">
                <button @click="addProfile()" class="btn btn-purple w-100">{{ $t('btn_save') }}</button>
            </div>
        </div>
    </div>
</template>

<script>

import Heading from './../snippets/Heading.vue'
import BillingProfile from './../snippets/BillingProfile.vue'

import { mapActions, mapState, mapGetters } from 'vuex'

export default {
    components: {
        Heading,
        BillingProfile
    },
    data: function() {
        return {

            profile: Object,

            errorMsgs: {
                first_name: '',
                last_name: '',
                address: '',
                country: '',
                county: '',
                company: '',
                j_code: '',
                fiscal_code: ''
            },

            loading: false,
        }
    },
    computed: {
        ...mapGetters({
            manualProfileCompletion: 'profiles/getManualProfileCompletion'
        })
    },
    mounted() {
    },
    watch: {
    },
    methods: {

        ...mapActions({
            actionAddProfile: 'profiles/addProfile',
            setManualProfileCompletion: 'profiles/setManualProfileCompletion'
        }),

        updateProfileFromComponent(event) {
            this.profile = event.profile;
        },

        resetErrorMsgs() {
            this.errorMsgs = {
                first_name: '',
                last_name: '',
                address: '',
                country: '',
                county: '',
                company: '',
                j_code: '',
                fiscal_code: ''
            };
        },

        validate()
        {
            this.clearErrors(this.errorMsgs);

            var ok = true;

            Object.keys(this.profile).forEach(k => {
                if (typeof this.profile[k] == 'string') {
                    this.profile[k] = this.profile[k].trim();
                }
            });

            var mandatoryText = this.$t('mandatory');

            if(this.profile.billing_type == 'pj') {

                if(!this.profile.fiscal_code) {
                    ok = false;
                    this.errorMsgs.fiscal_code = mandatoryText;
                }

                if(!this.profile.company) {
                    ok = false;
                    this.errorMsgs.company = mandatoryText;
                }

                if(!this.profile.j_code) {
                    ok = false;
                    this.errorMsgs.j_code = mandatoryText;
                }

                if(!this.profile.city) {
                    ok = false;
                    this.errorMsgs.city = mandatoryText;
                }

                if(!this.profile.address) {
                    ok = false;
                    this.errorMsgs.address = mandatoryText;
                }
            }

            if(this.profile.billing_type == 'pf') {

                if(!this.profile.first_name) {
                    ok = false;
                    this.errorMsgs.first_name = mandatoryText;
                }

                if(!this.profile.last_name) {
                    ok = false;
                    this.errorMsgs.last_name = mandatoryText;
                }

                if(!this.profile.county && this.profile.country == 1) {
                    ok = false;
                    this.errorMsgs.county = mandatoryText;
                }

                if(!this.profile.city) {
                    ok = false;
                    this.errorMsgs.city = mandatoryText;
                }
            }

            return ok;
        },

        async addProfile() {

            // console.log(this.validate());
            // console.log(this.errrorMsgs);

            if(!this.validate()) return false;

            this.loading = true;

            try {
                if(this.manualProfileCompletion) {
                    this.profile.validated_cui = true;
                }

                let response = await this.actionAddProfile(this.profile);

                this.setManualProfileCompletion(false);

                this.$router.go(-1);

            } catch (err) {
                this.loading = false;

                if(err.response) {
                    this.$dialog.alert({
                        'message': err.response.data.error.error_msg,
                        'confirmButtonText': this.$t('btn_i_understand')
                    });
                }
            }
        }
    }
}

</script>

<style lang="scss" scoped>

$lightgrey: lightgrey;
$green: #59af54;

.ancillary {
    color: #DCCCCD;
}

</style>
